module.exports = __webpack_public_path__ + "img/logo-nirvana-memorial-garden.86fe2ff5.a1a12f13.svg";